import type { StepProps } from '../useStepForm';

export function findNextStepByOrder<
  T extends Pick<StepProps<F>, 'id' | 'renderWhen'>,
  F extends Record<string, unknown>,
>(steps: T[], currentId: string, formData: F): T | undefined {
  let foundCurrent = false;
  return steps.find((step) => {
    if (step.id === currentId) {
      foundCurrent = true;
    } else if (foundCurrent) {
      return !step.renderWhen || step.renderWhen(formData);
    }

    return false;
  });
}
